<template>
  <div>
    <yv-index
      :bulkActions="tableBulkActions"
      :columns="columns"
      :enableExport="false"
      :formSearch="baseFormSearch"
      :formatTableData="formatTableData"
      :path="path"
      :sort-data="sortData"
      :sortable="sortable"
      :tableActionsComponent="TableActions"
      selectable="multiple"
      ref="censorSubmitted"
    ></yv-index>

    <common-modal
      width="80%"
      height="auto"
      name="ReviewerProgressReportForm"
      :hideFooter="true"
      :title="progressReport.title"
    >
      <template #modal-body>
        <StandardReport
          :generateVietnamese="generateVietnamese"
          :reportType="progressReport.report_template"
          :progress="progressReport"
          :isDisable="false"
          mode="reviewer"
          modalName="ReviewerProgressReportForm"
          @reloadData="reloadData"
        >
        </StandardReport>
      </template>
    </common-modal>
  </div>
</template>

<script>
import YvIndex from "../../../components/Base/YvIndex";
import TableActions from "../SubmittedReport/TableActions";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { mapGetters } from "vuex";
import { ProgressReport } from "@/constants/Permissions";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import StandardReport from "../SubmittedReport/StandardReport";
import debounce from "lodash/debounce";
import {
  ReportTemplates,
  StatusReports,
  SubjectReports
} from "../../../constants/Report";
import { generateStatusReport } from "../../../helpers/text-helper";

export default {
  components: {
    YvIndex,
    StandardReport
  },
  data() {
    return {
      ProgressReport,
      path: `${service_paths.progress}/submitted/report?subject=Review&status=Pending`,
      baseFormSearch: [
        {
          label: "submitted_report.search_title",
          name: "search_key",
          value: "",
          type: "text",
          width: "33"
        },
        {
          label: "submitted_report.date_sending_report",
          name: "date_or_sending",
          value: [],
          type: "date-range",
          width: "33"
        },
        /*{
         label: "common.status",
         name: "status",
         value: "Pending",
         type: "select",
         options: [{ id: "Pending", name: "progress_report.pending" }],
         width: "33"
         },*/
        {
          label: "common.class",
          name: "class_ids",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name",
          filtering: this.searchClass,
          width: 33
        }
      ],
      columns: {
        date_sending: "submitted_report.date_of_sending",
        last_inputter: "submitted_report.last_inputter",
        student_name: "submitted_report.report_of_the_student",
        report_status: "common.status",
        last_reviewer: "submitted_report.last_reviewer"
      },
      sortable: ["report_status"],
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      TableActions,
      progressReport: {},
      tableBulkActions: [
        {
          content: this.$t("submitted_report.approve"),
          action: () => {
            this.confirmApprove();
          }
        },
        {
          content: this.$t("submitted_report.reject"),
          action: () => {
            this.confirmReject();
          }
        }
      ],
      selectedItems: [],
      searchParam: {
        search_key: "",
        date_or_sending: "",
        status: "Pending"
      },
      classesSelected: []
    };
  },
  created() {
    this.getListClass();
    if (
      this.$can(
        this.ProgressReport.actions.censorSubmittedReport,
        this.ProgressReport.subject
      )
    ) {
      this.baseFormSearch.unshift({
        label: "submitted_report.reviewer",
        name: "inputter_or_reviewer_id",
        value: "",
        type: "select",
        options: [],
        width: "33"
      });
      this.getReviewer();
    }
  },
  watch: {
    listClassSelected() {
      let classOptions = this.baseFormSearch.find(
        item => item.name === "class_ids"
      );
      this.classesSelected = classOptions.options.filter(item =>
        classOptions.value.includes(item.id)
      );
    }
  },
  computed: {
    generateVietnamese() {
      const isDisplay =
        this.progressReport.report_template === ReportTemplates.Standard
          ? "block"
          : "hidden";
      return "italic font-mono " + isDisplay;
    },

    listClassSelected() {
      return this.baseFormSearch.find(item => item.name === "class_ids").value;
    },

    ...mapGetters("user", {
      userInfo: "info"
    })
  },
  methods: {
    formatTableData(tableData) {
      tableData.forEach(data => {
        data.date_sending = convertDateFromServer(data.updated_at, "date");
        data.last_inputter = data?.inputter?.full_name;
        data.student_name = data.student?.full_name;
        data.report_status = generateStatusReport(data.status);
        data.last_reviewer = data?.reviewer?.full_name;
      });
      return tableData;
    },

    searchClass(e) {
      this.debounceClass(e);
    },
    debounceClass: debounce(function(searchKey) {
      this.getListClass(searchKey);
    }, 500),
    getListClass(searchKey = "") {
      this.$axios
        .get(
          `${service_paths.classes}`,
          {
            "name__~": searchKey,
            limit: 50
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          let newOptions = data.data.filter(
            item => !this.listClassSelected.includes(item.id)
          );
          let classOptions = this.baseFormSearch.find(
            item => item.name === "class_ids"
          );
          classOptions.options = [...this.classesSelected, ...newOptions];
        });
    },

    getReviewer() {
      let options = [];
      this.$axios
        .get(`${service_paths.progress}/staffs`, {
          subject: SubjectReports.Review
        })
        .then(res => {
          options = res.data.map(reviewer => ({
            id: reviewer.staff_id,
            name: reviewer.staff?.full_name
          }));
          this.baseFormSearch[0].options = [...DEFAULT_OPTION_ALL, ...options];
        });
    },

    bulkConfirm(status) {
      // let progressIds = this.selectedItems.map(progress => progress._id);
      let progressIds = this.$refs.censorSubmitted.selectedItems.map(
        progress => progress._id
      );
      let body = {
        status: status,
        array_progress_id: progressIds
      };
      this.$axios
        .put(`${service_paths.progress}/update/multiple`, body)
        .then(() => {
          if (status === StatusReports.Official) {
            Message.success(this.$t("submitted_report.approve_success"));
            this.$axios.post(
              `${service_paths.export}/multiple/progress-report`,
              {
                array_progress_id: progressIds
              }
            );
          } else {
            Message.success(this.$t("common.update_success"));
          }
          // Reload table data
          this.$refs.censorSubmitted.getTableData();
        });
    },

    confirmApprove() {
      this.bulkConfirm(StatusReports.Official);
    },

    confirmReject() {
      this.bulkConfirm(StatusReports.Not_approve);
    },

    onSelectItems(items) {
      this.selectedItems = items;
    },

    reloadData() {
      this.$refs.censorSubmitted.getTableData();
    },

    viewSubmittedReport(item) {
      this.progressReport = item;
      this.$modal.show("ReviewerProgressReportForm");
    }
  },
  provide() {
    return {
      viewSubmittedReport: this.viewSubmittedReport
    };
  }
};
</script>
